import { AUTHORIZATION_HEADER } from '../../../../../../src/authorization';
import { send } from '../../../../../../src/network';

export type OrderFeedbackQuestionType = 'amount' | 'value' | 'delivery';

export type OrderFeedbackQuestion = {
  id: number;
  name: string;
  description: string;
  thumbnail_url: string;
  type: OrderFeedbackQuestionType;
  order_id: number;
  answers: [
    {
      id: number;
      name: string;
    },
  ];
};

type Params = {
  type: OrderFeedbackQuestionType;
};

export const getCustomerOrderFeedbackQuestionsPath = (
  type: OrderFeedbackQuestionType
) => `/api/v2/customers/self/order_feedback_questions/${type}/`;

export async function getCustomerOrderFeedbackQuestions({ type }: Params) {
  return await send<{ results: OrderFeedbackQuestion[] }>({
    path: getCustomerOrderFeedbackQuestionsPath(type),
    method: 'GET',
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
